import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

// Define styles for the PDF
const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: "Helvetica" },
  header: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
  },
  chatContainer: { display: "flex", flexDirection: "column", gap: 10 },

  // Base bubble style
  bubbleWrapper: { display: "flex", flexDirection: "column", marginBottom: 8 },
  bubble: { padding: 10, borderRadius: 8, maxWidth: "75%", fontSize: 12 },

  // Author specific styles
  userWrapper: { alignItems: "flex-end" },
  aiWrapper: { alignItems: "flex-start" },

  userBubble: { backgroundColor: "#007AFF", color: "white" }, // Blue
  aiBubble: { backgroundColor: "#E5E5EA", color: "black" }, // Gray

  // Metadata
  authorName: { fontSize: 10, color: "#666", marginBottom: 2 },
  timestamp: {
    fontSize: 8,
    color: "#999",
    marginTop: 4,
    alignSelf: "flex-end",
  },
});

const TranscriptPDF = ({ data, user }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.header}>Simulation Transcript</Text>

      <View style={styles.chatContainer}>
        {data.map((entry) => (
          <View
            key={entry.id}
            style={[
              styles.bubbleWrapper,
              entry.ai_generated || !entry.is_user ? styles.aiWrapper : styles.userWrapper,
            ]}
          >
            <Text style={styles.authorName}>
              {entry.ai_generated || !entry.is_user ? "Avatar" : user?.first_name || "User"}
            </Text>

            <View
              style={[
                styles.bubble,
                entry.ai_generated || entry.is_user ? styles.aiBubble : styles.userBubble,
              ]}
            >
              <Text>{entry.message}</Text>
            </View>

            <Text style={styles.timestamp}>
              {new Date(entry.created_at).toLocaleString()}
            </Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default TranscriptPDF;
